import axios from './axios';

// api endpoints
const endpoints = {
  getUserList: '/api/manage/user',
  updateUserInfo: '/api/manage/user'
};

/**
 * Get the user information list
 *
 * @param token {string}    user token in profile
 *
 * @return {Promise<AxiosResponse<T>>}
 */

const getUserList = async token => {
  let result = undefined;

  const headers = {
    Authorization: `token ${token}`
  };

  try {
    result = await axios.get(endpoints.getUserList, { headers });
  } catch (error) {
    console.log(error);

    result = error;
  }

  return result;
};

/**
 * Update specified user profile by email
 *
 * @param token {string}    User token in profile
 * @param email {string}    User email
 * @param data  {object}    Payload of the request
 * @param data.Admin {boolean}    Is user a admin
 * @param data.MaxLicenseDay {number}    The max period in license request doesn't need an approval
 *
 * @return {Promise<AxiosResponse<T>>}
 */

const updateUserInfo = async (token, email, data) => {
  let result = undefined;

  const headers = {
    Authorization: `token ${token}`,
    'Content-Type': 'application/json'
  };

  const url = `${endpoints.getUserList}/${email}`;

  try {
    result = await axios.post(url, data, { headers });
  } catch (error) {
    console.log(error);

    result = error;
  }

  return result;
};

export default {
  getUserList,
  updateUserInfo
};
